// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckOutlinedSvg from "@fishx/icons-svg/es/asn/CheckOutlined";
import FishxIcon from '../components/FishxIcon';

var CheckOutlined = function CheckOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckOutlinedSvg
  }));
};

CheckOutlined.displayName = 'CheckOutlined';
export default React.forwardRef(CheckOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CheckOutlined.js
// module id = 2193
// module chunks = 0